import {Element} from '@chaysehartsuff/active-html';
import Message from './Message.js';
import AloTextarea from './AloTextarea.js';

export default class ChatMessageInput extends Element {

	/**
	 * @type {AloTextarea}
	 */
	textarea;

	/**
	 * @var {Message} replyMessage
	 */
	replyMessage;


	constructor() {
		super();
		this.addClass('flex flex-col');
		this.replyContainer = new Element().addClass('hidden mb-2');
		this.textarea = new AloTextarea();
		this.addContent(this.replyContainer, 'replyContainer', 0);
		this.addContent(this.textarea);
	}

	getTextarea(){
		return this.textarea;
	}

	getReplyMessage(){
		return this.replyMessage;
	}

    /**
	 * @param {Message} message 
	 */
	setReplyMessage(message){
		if(!message || !message.publicMessage){
			return this.removeReplyMessage();
		}

		this.replyMessage = message;
		const targetId = String(message.getId());
		const replyLink = new Element('a')
			.addContent(`@${message.publicMessage.name}`)
			.addClass('text-emerald-300 hover:text-emerald-200 underline underline-offset-2 cursor-pointer')
			.setAttribute('href', `#${targetId}`)
			.onEvent('click', (e) => {
				e.preventDefault();
				const resolvedMessage = Element.createInstanceFromId(targetId);
				if (!resolvedMessage) {
					return;
				}

				resolvedMessage.removeContent('highlight');
				const highlightOverlay = new Element()
					.addClass('absolute inset-0 rounded-xl border-2 border-emerald-300/95 bg-emerald-300/10 shadow-[0_0_0_2px_rgba(110,231,183,0.65),0_0_28px_rgba(16,185,129,0.35)] pointer-events-none opacity-100 transition-opacity duration-[1400ms] ease-out');
				resolvedMessage.addContent(highlightOverlay, 'highlight');

				window.setTimeout(() => {
					highlightOverlay.removeClass('opacity-100');
					highlightOverlay.addClass('opacity-0');
				}, 30);

				window.setTimeout(() => {
					resolvedMessage.removeContent('highlight');
				}, 1600);

				const target = document.getElementById(targetId);
				if(target){
					target.scrollIntoView({behavior: 'smooth', block: 'center'});
				}
			});

		const clearButton = new Element('button')
			.setAttribute('type', 'button')
			.addClass('text-white/70 hover:text-white text-xs tracking-[0.08em] px-2 py-1 rounded border border-white/20 hover:border-white/40')
			.addContent('x')
			.onEvent('click', () => {
				this.removeReplyMessage();
			});

		const replyIndicator = new Element()
			.addClass('w-full rounded-t-xl rounded-br-xl border border-white/15 bg-black/40 px-3 py-2 text-xs text-white/80 flex items-center justify-between')
			.addContent(
				new Element()
					.addClass('flex items-center gap-2')
					.addContent(new Element('span').addClass('text-white/60').addContent('Replying to'))
					.addContent(replyLink)
			)
			.addContent(clearButton);

		this.replyContainer.clearContent();
		this.replyContainer.addContent(replyIndicator, 'replyMessage');
		this.replyContainer.removeClass('hidden');
		return this;
	}

	removeReplyMessage(){
		this.replyMessage = null;
		this.replyContainer.removeContent('replyMessage');
		this.replyContainer.addClass('hidden');
		return this;
	}

}